/**
 * November 2017 - interface moved from odsp-next
 */

export enum UpdatePermissionsRole {
    NONE,
    VIEW,
    EDIT
}

export interface IUpdatePermissionsResponse {
    role: UpdatePermissionsRole;
    success?: boolean;
}
